/* eslint-disable */
import React from 'react';
import MonthlySchedule from '../../../component/teacher/MonthlySchedule';
import 'contents/assets/scss/page/teacher.scss';
function TeacherClassSchedule() {
  return (
    <main className="com_container p_classinfo">
      <div className="com_center_wrap">
        <section className="com_tit_wrap">
          <h2 className="com_pg_tit icon menu2_13">
            수업 일정 <span className="bar" />
            <span className="point_txt">홍교사103ㆍ수학</span>
          </h2>
          <div className="com_btn_wrap">
            <button onClick={() => setModalOpen(true)} className="com_btn orange s btn_plus">
              인센티브 지급
            </button>
          </div>
        </section>
        <section className="com_pg_container">
          <div className="box full">
            <MonthlySchedule />
          </div>
        </section>
      </div>
    </main>
  );
}
export default TeacherClassSchedule;
